import axios from 'config/axios';

export const fetchCompanySelectedStandards = async ({ params }) => {
    try {
      const updatedParams = {};
      if (params.companyid) {
        updatedParams.company = params.companyid;
      }
      let response = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/selectedstandardsbycompany`,{
        params: updatedParams,
         'Content-Type': 'application/json',
      });
      return response.data;
    } catch (error) {
      return error;
    }
  };



  export const fetchMitigationAssessmentReportsquery =  async ({ params }) => {
    try {
        let  response = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getAssessmentReportsquery`,
        {
           params:params,
          'Content-Type': 'application/json',
        });
        return response.data;   
    } catch (error) {
    }
  };

  

  export const fetchHistoricalAssessmentReportsquery =  async ({ params}) => {
    try {
      const updatedParams = { ...params, page: params.page, limit: params.limit,status:'Completed' };   
      let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getHistoricalAssessmentReports`,
      {
        params:updatedParams,  
      });
      return response.data;          
    } catch (error) {
      return error;
    }
  };

  export const fetchUserHistoricalAssessmentReportsquery =  async ({ params, idToken }) => {
    try {
      const headers = {
        Authorization: `Bearer ${idToken}`,
      };
     
      if(params.standardid === null){
        let  response = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getAssessmentReportsquery?company=`+params.companyid+ `&user=`+params.userid+`&status=Completed`,
        {
            headers: headers,
          'Content-Type': 'application/json',
        });
        return response.data;
    }else{
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getAssessmentReportsquery?company=`+params.companyid+ `&user=`+params.userid+`&standard=`+params.standardid+ `&status=Completed`,
        {
            headers: headers,
          'Content-Type': 'application/json',
        });
        
        return response.data;   
            }
   
    } catch (error) {
    }
  };

  export const fetchAuditTrailDetailsByAssessment =  async ({ params}) => {
    try {
    let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getAuditTrail?assessment_id=`+params.assessmentid,{});    
    return response.data;     
    } catch (error) {
      return error;
    }
  };

  export const fetchCompanyUsers =  async ({ params }) => {
    try {
      let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getusers`,
      {
        params: params,
        'Content-Type': 'application/json',
      });
      return response.data;   
    } catch (error) {
      return error;
    }
  };

  export const fetchStandardsByUser =  async ({ params}) => {
    try {
      let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/userselectedstandards?company=`+params.companyid+ `&user=`+params.userid,
      {
        'Content-Type': 'application/json',
      });
      return response.data.userStandards;   
    } catch (error) {
      return error.response;
    }
  };

  export const fetchAssessmentsByUser =  async ({ params}) => {
    try {
     
      let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getPendingAssessmentReports?company=`+params.companyid+ `&user=`+params.userid,
      {
        'Content-Type': 'application/json',
      });  
      return response.data;   
    } catch (error) {
      return error.response;
    }
  };

  export const fetchAssessmentsByUserStandard =  async (params) => {
    try {
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getPendingAssessmentReports`,
        {
          params: params,
        'Content-Type': 'application/json',
        });
        
        return response;   
    } catch (error) {
      return error;
    }
  };
  /*export const fetchAssessmentReportdetailsforReview =  async ({ params}) => {
    try {
         
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getassessmentReportdetailsforReview`, {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            assessment_id: params.assessment_id, //code change
          },
        });
        
        return response;   
      
   
    } catch (error) {
      return error.response;
    }
  }; */
  export const fetchAssessmentReportdetailsforReview = async (params) => {
    try {
  
      let response = await axios.get(
        `${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getassessmentReportdetailsforReview`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            assessment_id:
              params?.assessment_id ||
              params?.assessmentid ||
              params?.params?.assessment_id || //code change to fix mitigation page
              params?.params?.assessmentid,
          },
        }
      );
  
      return response;
  
    } catch (error) {
      return error.response;
    }
  };

  export const fetchAssessmentReportdetailsBySeverity =  async ({ params}) => {
    try {         
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getAssessmentreportDetailsBySeverity`, {
          headers: {
            'Content-Type': 'application/json',
          },
          params,
        });        
        return response;   
    } catch (error) {
      return error.response;
    }
  };

  export const fetchStandardsByCompany = async (params) => {
    try {
      const updatedParams = {};
      if (params.companyid) {
        updatedParams.company = params.companyid;
      }
      let response = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/selectedstandards`,{
        params: updatedParams,
         'Content-Type': 'application/json',
      });
      return response;
    } catch (error) {
      return error?.response?.data?.message;
    }
  };

  export const fetchStandardsByStandard = async (params) => {
    try {
      let response = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getstandardsquery`,{
        params: params,
         'Content-Type': 'application/json',
      });
      return response;
    } catch (error) {
      return error;
    }
  };
  export const fetchDashboardAssessmentReports = async (params) => {
    try {
      let response = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getDashboardAssessmentReports`,{
        params: params,
         'Content-Type': 'application/json',
      });
      return response;
    } catch (error) {
      return error;
    }
  };
  export const fetchPendingAssessmentReportsCount =  async (params) => {
    try {
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getPendingAssessmentReportsCount`,
        {
          params: params,
        'Content-Type': 'application/json',
        });
        
        return response;   
    } catch (error) {
      return error;
    }
  };


  export const fetchAssessmentDataByAssessmentId =  async ({ params, idToken }) => {
    try {
         
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getAssessmentReportsquery`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
          params: params,
        });
        
        return response;   
      
   
    } catch (error) {
    }
  };
  export const fetchAllStatus =  async () => {
    try {
      let  response = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getAllStatus`,{});
      return response;
    } catch (error) {
     return error; 
    }
  };

  export const saveAssignAssessment= async({body})=>{
    try{
      let response= await axios.post(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/newAssessment`,body,
      {
        'Content-Type': 'application/json',
      });
     return response;
    }catch(error){
      return error.response;
    }

  }
  
  export const fetchAssessmentReportdetailsByAssessmentId =  async (params) => {
    try {
         
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/AssessmentReportDetails`, {
          params: {
            assessment_id: params.assessmentid,
          },
        });
        if(response?.status===200)
        return response;   
      
   
    } catch (error) {
      
    }
  };

  export const fetchStandardOptions =  async (params) => {
    try {
         
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/getStandardOptions`, {
          params,
        });
        if(response?.status===200)
        return response;         
    } catch (error) {
      console.log(error);
    }
  };

  export const fetchAllStandardsByStandard =  async (params) => {
    try {
         
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/controls`, {
          headers: {
            'Content-Type': 'application/json',
          },
          params: params,
        });
        if(response?.status===200)
        return response;   
      
   
    } catch (error) {
      
    }
  }
  export const fetchAllPredefineStandardsByStandard =  async (params) => {
    try {
         
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/domaincontrols`, {
          headers: {
            'Content-Type': 'application/json',
          },
          params: params,
        });
        if(response?.status===200||response?.status===201)
        return response;   
      
   
    } catch (error) {
      
    }
  };


  export const fetchSubControlsByStandardControlID =  async (params) => {
    try {
     
        let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/subcontrols`, {
          headers: {
            'Content-Type': 'application/json',
          },
          params: params,
        });
        if(response?.status === 200 || response?.status === 201)
        return response;   
      
   
    } catch (error) {
      
    }
  };
  export const submitAssessmentReport= async(data)=>{
    try{
      let response= await axios.post(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/AssessmentReport/submit`,data,
      {
      'Content-Type': 'application/json',
    });
    if(response?.status === 200 || response?.status === 201)
     return response;
    }catch(error){
      // US-CAP-302: Surface 4xx responses (e.g. missing mandatory evidence,
      // assessment on hold) instead of silently swallowing them — the caller
      // needs error.response.data.message to show the user what went wrong.
      if (error?.response) return error.response;
      throw error;
    }

  }
  export const pendingAssessmentCount= async({idToken,params})=>{
    try{
      const headers = {
        Authorization: `Bearer ${idToken}`,
      };
      // let response= await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getPendingAssessmentReportsByUser`,
      let response= await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getPendingAssessmentReportsByUser`,
      {
        headers: headers,
        params:params,
    });
     return response;
    }catch(error){
      
    }

  }

    export const fetchStandards = async(param)=>{
    try{
      let response = await  axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/getallstandards?group=${encodeURIComponent(param)}`,{
      })
      return response;
    }catch(error){
      return error;   
    }
    
  }
 

  export const fetchSelectedStandardsById = async({companyId})=>{
    try{
      let response = await axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/selectedstandards?company=${companyId}`,{
      })
      return response;
    }catch(error){
      return error;   
    }
    
  }
  export const fetchAllStandards = async(param)=>{
    try{
      let response = await  axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/getallstandards?group=${encodeURIComponent(param)}`,{
      })
      return response;
    }catch(error){
      return error;   
    }
    
  }
  export const updateStandards = async(data)=>{
    try{
      let response = await axios.put(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/updatestandards`,data,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const saveNewStandard= async({body})=>{
    try{
      let response= await axios.post(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/createNewStandard`,body,
      {
        'Content-Type': 'application/json',
      });
     return response;
    }catch(error){
      return error.response;
    }

  }
  //TE for Duplicate control ID Commented following prev code to replace with follows
  // export const saveNewControlByStandard= async({standard,body})=>{
  //   try{
  //     let response= await axios.post(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/createNewcontrols?standard=`+standard,body,
  //     {
  //       'Content-Type': 'application/json',
  //     });
  //    return response;
  //   }catch(error){
  //     return error.response;
  //   }
  // }
  //TE for Duplicate control ID start
  export const saveNewControlByStandard = async ({ standard, body }) => {
  try {

    const response = await axios.post(
      `${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/createNewcontrols?standard=` + standard,
      body,
      {
        'Content-Type': 'application/json',
      }
    );

    return response;

  } catch (error) {

    console.log("Backend Error:", error);

    return {
      status: error?.response?.status || 500,
      data: error?.response?.data || { message: "Something went wrong" }
    };
  }
};
  //TE for Duplicate control ID end
  export const saveNewQuestionByStandardControl= async({standard,body})=>{
    try{
      let response= await axios.post(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/createNewSubcontrols?standard=`+standard,body,
      {
        'Content-Type': 'application/json',
      });
     return response;
    }catch(error){
      return error.response;
    }
  }

  export const fetchControlsByStandardId = async({standard})=>{
    try{
      let response = await axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/master/getControlsByStandard?Standard=${standard}`,{
      })
      return response;
    }catch(error){
      return error;   
    }
    
  }


  export const fetchSubControlsByStandardControl = async({standardId,controlId})=>{
    try{
      let response = await axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/master/getSubControlsByStandardControl?standard=${standardId}&control=`+controlId,{
      })
      return response;
    }catch(error){
      return error;   
    }
    
  }
  export const updateStandardById = async(standarId,{body})=>{
    try{
      let response = await axios.put(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/updatestandard/`+standarId,body,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const updateControlsById = async(controlId,standarId,{body})=>{
    try{ 

      let response = await axios.put(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/updateControlsByID/`+controlId+'?standard='+standarId,body,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const updateSubcontrolsById = async(subcontrolId,standarId,{body})=>{
    try{
      let response = await axios.put(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/updateSubcontrolsByID/`+subcontrolId+'?standard='+standarId,body,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const updateControlsweightages = async(standarId,{body})=>{
    try{
      let response = await axios.put(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/updateMultipleControls?standard=`+standarId,body,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const saveNewStandardByComapny= async({body})=>{
    try{
      let response= await axios.post(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/createNewStandardsByCompany`,body,
      {
        'Content-Type': 'application/json',
      });
     return response;
    }catch(error){
      throw error; // Code change for duplicate standard name
    }
  }

  export const createNewStandardByCompany = async(body)=>{
    try{
      let response = await axios.post(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/createNewStandardByTemplate`,body,{
        'Content-Type': 'application/json',
      });
      return response;
    }catch(error){
      return error.response;
    }
  }
  // Creating new standard from Excel file data
  export const createNewStandard = async(body)=>{
    try{
      let response = await axios.post(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/addNewStandard`,body,{
        'Content-Type': 'application/json',
      });
      return response;
    }catch(error){
      return error.response;
    }
  }
  export const saveNewControlByCompanyStandard= async({standard,body})=>{
    try{
      let response= await axios.post(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/createNewControlsByCompany?standard=`+standard,body,
      {
        'Content-Type': 'application/json',
      });
     return response;
    }catch(error){
      throw error; // Code change for control id error
    }
  }
  export const saveNewQuestionByCompanyStandardControl= async({standard,body})=>{
    try{
      let response= await axios.post(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/createNewSubcontrolsByCompany?standard=`+standard,body,
      {
        'Content-Type': 'application/json',
      });
     return response;
    }catch(error){
      return error.response;
    }
  }
  export const fetchCompanyStandardsByCompany = async({group,companyId})=>{
    try{
      let response = await  axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/getAllstandardsByCompany?group=${encodeURIComponent(group)}&company=`+companyId,{
      })
      return response;
    }catch(error){
      return error;   
    }
    
  }

  export const fetchCompanyStandardsByCompanyQuery = async({params})=>{
    try{
      let response = await  axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/getAllstandardsByCompany`,{
        headers: {
          'Content-Type': 'application/json',
        },
        params: params,
      })
      return response;
    }catch(error){
      return error;   
    }
    
  }

  export const fetchControlsByCompanyStandardId = async(params)=>{
    try{
      let response = await axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/getCompanyControlsByStandard`, {
        headers: {
          'Content-Type': 'application/json',
        },
        params: params,
      })
      return response;
    }catch(error){
      return error;   
    }
    
  }

//code change in let response
  export const fetchSubControlsByCompanyStandardControl = async({standardId,controlId,companyId})=>{
    try{
      let response = await axios.get(
        `${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/getCompanySubControlsByStandard?Standard=${standardId}&company=${companyId}&ControlID=${controlId}`
      );
      return response;
    }catch(error){
      return error;   
    }
    
  }

  export const updateCompanyStandardById = async(standarId,{body})=>{
    try{
      let response = await axios.put(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/updateCompanyStandard/`+standarId,body,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const updateCompanyControlsById = async(controlId,standarId,{body})=>{
    try{ 

      let response = await axios.put(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/updateCompanyControlsByID/`+controlId+'?standard='+standarId,body,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const updateCompanySubcontrolsById = async(subcontrolId,standarId,{body})=>{
    try{
      let response = await axios.put(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/updateCompanySubcontrolsByID/`+subcontrolId+'?standard='+standarId,body,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const updateCompanyControlsweightages = async(standarId,{body})=>{
    try{
      let response = await axios.put(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/updateCompanyMultipleControls?standard=`+standarId,body,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }
  export const syncMasterStandardsById = async(standardId)=>{
    try{ 

      let response = await axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/syncStandards?standard=`+standardId,
        {
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const syncCompanyStandardsById = async(params)=>{
    try{
      let response = await axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/syncCompanyStandards`,
        {
          params: params,
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const fetchCompanySchemaByStandardId = async(params)=>{
    try{
      let response = await axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/getCompanySchemaByStandard`,
        {
          params: params,
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
  }

  export const fetchMasterSchemaByStandardId = async(params)=>{
    try{
      let response = await axios.get(`${process.env.REACT_APP_CAP_CONFIGURATION_ENDPOINT_URL}/standards/getMasterSchemaByStandard`,
        {
          params: params,
          'Content-Type': 'application/json',
        }
      )
      return response;
    }catch(error){
      return error;   
    }
}
  
// US-CAP-106: Reviewer assigns manual score to a text_box assessment detail
export const patchAssessmentDetailScore = async (detailId, score_contribution) => {
  try {
    let response = await axios.patch(
      `${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/details/${detailId}/score`,
      { score_contribution },
      { 'Content-Type': 'application/json' }
    );
    return response;
  } catch (error) {
    return error;
  }
};